import FiniteDataBinning from './FiniteDataBinning.js';

class StrikeZoneDataBinning extends FiniteDataBinning {
    constructor() {
        super(1, 1, 15);
    }
}

export default StrikeZoneDataBinning;